// Maps a dropped / posted "card" shape to the typed (kind, content, payload)
// insert args. Unknown cardType falls back to kind='text' with the raw JSON
// in content so drops are never silently dropped.

export type CardKindMapResult = {
  kind:
    | "run"
    | "terminal_output"
    | "terminal_snapshot"
    | "command_history"
    | "email"
    | "calendar"
    | "text";
  content: string;
  payload: Record<string, unknown> | null;
};

export function mapDroppedCard(
  cardType: string,
  parsed: Record<string, unknown>,
): CardKindMapResult {
  switch (cardType) {
    case "run":
      return { kind: "run", content: "", payload: parsed };
    case "terminal-output":
      return { kind: "terminal_output", content: "", payload: parsed };
    case "terminal-snapshot":
      return { kind: "terminal_snapshot", content: "", payload: parsed };
    case "command-history":
      return { kind: "command_history", content: "", payload: parsed };
    case "email":
      return { kind: "email", content: "", payload: parsed };
    case "calendar":
      return { kind: "calendar", content: "", payload: parsed };
    default:
      return {
        kind: "text",
        content: JSON.stringify(parsed),
        payload: null,
      };
  }
}
